"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComparisonBarActions = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Icon = require("b2b-components/theme/components/Icon");
var _key = require("b2b-components/utils/key");
require("./ComparisonBarActions.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ComparisonBarActions = _ref => {
  let {
    isVisible,
    actions
  } = _ref;
  const [isMenuOpen, setIsMenuOpen] = (0, _react.useState)(false);
  const handleMenuToggle = () => {
    setIsMenuOpen(previousValue => !previousValue);
  };
  (0, _react.useEffect)(() => {
    if (!isVisible) {
      setIsMenuOpen(false);
    }
  }, [isVisible]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ComparisonBarActions"
  }, /*#__PURE__*/_react.default.createElement(_ButtonIcon.ButtonIcon, {
    icon: _ButtonIcon.BUTTON_ICON_ICON_NAME.dots,
    size: _ButtonIcon.BUTTON_ICON_SIZE.medium,
    styleType: _Button.BUTTON_STYLE_TYPE.negative,
    onClick: handleMenuToggle
  }), isMenuOpen && /*#__PURE__*/_react.default.createElement("ul", {
    className: "cds-ComparisonBarActions-Menu"
  }, actions.map((action, index) => /*#__PURE__*/_react.default.createElement("li", {
    key: (0, _key.createKey)(action.label, index),
    className: "cds-ComparisonBarAction"
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: action.onClick,
    className: "cds-ComparisonBarAction-IconBox"
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: action.icon,
    size: _Icon.ICON_SIZE.small,
    className: "cds-ComparisonBarAction-Icon"
  })), /*#__PURE__*/_react.default.createElement("span", {
    onClick: action.onClick,
    className: "cds-ComparisonBarAction-Label"
  }, action.label), /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-ComparisonBarAction-Description"
  }, action.description)))));
};
exports.ComparisonBarActions = ComparisonBarActions;
//# sourceMappingURL=ComparisonBarActions.js.map